import { render, staticRenderFns } from "./Learnings.vue?vue&type=template&id=fcb8731c&"
import script from "./Learnings.vue?vue&type=script&lang=js&"
export * from "./Learnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports